import { createContext } from 'react';
const UserModuleContext = createContext({});

export default UserModuleContext;
